import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

/** Storage/upload signed-URL and long-poll contracts stay intentionally loose: handlers keep exact validation order and status branching. */
const storageObject = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
}).passthrough()


export const trainerProfilePhotoStartResponseSchema = storageObject
export type TrainerProfilePhotoStartResponse = z.infer<typeof trainerProfilePhotoStartResponseSchema>

export const trainerProfilePhotoCompleteResponseSchema = storageObject
export type TrainerProfilePhotoCompleteResponse = z.infer<typeof trainerProfilePhotoCompleteResponseSchema>

export const trainerProfilePhotoSignedReadResponseSchema = storageObject
export type TrainerProfilePhotoSignedReadResponse = z.infer<typeof trainerProfilePhotoSignedReadResponseSchema>
